import IconStyle, { defaultProps } from './IconStyle';
export { defaultProps };
export default IconStyle;
//# sourceMappingURL=Icon.js.map